// Los rangos de monto de la píldora "Monto" y de "¿De qué tamaño?" del onboarding.
// Espejo de `AMOUNT_RANGES` en `backend/src/services/onboarding.service.ts`:
// mínimo incluido, máximo no; `null` = sin tope.
export const AMOUNT_RANGES: Array<{ min: number; max: number | null; label: string }> = [
  { min: 0, max: 1_000_000, label: "Hasta S/ 1M" },
  { min: 1_000_000, max: 5_000_000, label: "S/ 1M a S/ 5M" },
  { min: 5_000_000, max: 20_000_000, label: "S/ 5M a S/ 20M" },
  { min: 20_000_000, max: null, label: "Más de S/ 20M" },
];

/** El nombre del rango elegido, o "Cualquiera" si no hay tope. */
export function amountRangeLabel(min?: number | null, max?: number | null): string {
  if (min == null && max == null) return "Cualquiera";
  return (
    AMOUNT_RANGES.find((range) => range.min === min && range.max === (max ?? null))
      ?.label ?? "Personalizado"
  );
}
